
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 15.588a1.084 1.084 0 01-.769-.318l-5.015-5.015a.732.732 0 01.522-1.253.736.736 0 01.52.212l4.739 4.738 4.74-4.74a.74.74 0 01.522-.21.732.732 0 01.517 1.253l-5.013 5.014a1.081 1.081 0 01-.763.319z","fill":"currentColor"}})])
          )
        }
      }
    